import { Link } from '@tanstack/react-router';
import { usePode } from '@/api/me';
import { ApiError } from '@/lib/api';

/** 422 ALIQUOTA_INTERNA_AUSENTE: a UF (origem ou destino) nao tem alíquota interna na tabela legal do ICMS. */
export function ehErroAliquotaInternaAusente(erro: unknown): boolean {
  return erro instanceof ApiError && erro.code === 'ALIQUOTA_INTERNA_AUSENTE';
}

/**
 * Acao abaixo da mensagem da API: quem administra a tabela legal (permissao tenants.gerenciar, SUPERADMIN) ganha o link para
 * cadastrar a alíquota; os demais so leem o aviso. A mensagem em si e a da API, sem reescrever.
 */
export function AcaoAliquotaInterna() {
  const { pode } = usePode();
  if (!pode('tenants.gerenciar')) {
    return <span className="text-ink-secondary">Peça ao administrador para cadastrar a alíquota interna dessa UF na tabela legal do ICMS.</span>;
  }
  return (
    <Link
      to="/configuracoes/tabela-legal-icms"
      className="rounded-sm font-medium text-primary underline-offset-2 outline-none hover:underline focus-visible:shadow-focus"
    >
      Cadastrar alíquota
    </Link>
  );
}
